async function init(): Promise<void> {
  const env: string = process.env.REACT_APP_ENV ?? process.env.NODE_ENV ?? ''
  const isDev = env === 'development' || env === 'dev'
  const mockApi = process.env.REACT_APP_MOCK === 'mock_api'

  console.log('ENV:', env)

  if (mockApi && isDev) {
    // Dynamically import so it’s only bundled in dev
    const { enableManualMocks } = await import('./api/mocks/manualMocks')
    enableManualMocks()
  }

  await import('./initApp')
}

void init()
